import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState, dynamicTitles, dynamicTitlesKey, formatMessage } from 'src/api';

import { Icon } from '../../../Partials';
import 'src/assets/sass/theme/theme.scss';
import { ProjectsDispatcher } from 'src/app/Container';
import LoadingSpinner from 'src/app/Partials/LoadingSpinner/LoadingSpinner';
import { ProjectModel } from 'franke-trough-dependencies';
import { Link } from 'react-router-dom';
import ProjectListItem from './ListItem/ProjectListItem';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ProjectList.messages';

import './ProjectList.scss';

export interface ProjectListPageProps {
  dispatch: any;
  projects: GlobalPrivateState['projects'];
}

export interface ProjectListState {
  idOfActiveSettings?: string;
}

export class ProjectListPartial extends React.Component<ProjectListPageProps, ProjectListState> {
  constructor(props: ProjectListPageProps) {
    super(props);
    this.state = {};
    this.handleSettings = this.handleSettings.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(dynamicTitles.add({
      key: dynamicTitlesKey.dashboard,
      value: formatMessage(MESSAGES.projectListHeadline),
    }));
  }

  public render() {
    const { projects } = this.props;
    
    return (
      <div className="page-adresses">
          <ProjectsDispatcher />
          {projects.updating && !projects.loaded && (
            <div className="loading-screen">
              <LoadingSpinner />
            </div>
          )}
          {projects.loaded && !projects.updating && (
            <>
              <div className="grid pt-5 pb-5">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="box add d-flex justify-content-center align-items-center">
                        <div className="inner text-center">
                          <Link to="/profile/projects/new">
                            <Icon name="plus" size={'large'} />
                            <FormattedMessage {...MESSAGES.projectListAdd} />
                          </Link>
                        </div>
                      </div>
                    </div>
                    {this.projects && this.projects.map((project, index) => {
                      const key = `projects_list_item_${index}`;
                      return (
                        <div key={key} className="col-12 col-md-6 col-lg-4">
                          <div className="box d-flex">
                            <ProjectListItem
                              projects={project} 
                              onShowSettings={this.handleSettings}
                              showSettings={this.state.idOfActiveSettings === project.id}  
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          )}
      </div>
    );
  }

  private get projects(): ProjectModel[] | undefined {
    const { projects } = this.props;
    if (!projects.result || projects.result && projects.result.length === 0) {
      return;
    }

    return projects.result;
  }

  private handleSettings(id?: string) {
    this.setState({
      idOfActiveSettings: id,
    });
  }
}

export const ProjectList = connect((state: GlobalPrivateState) => ({
  projects: state.projects,
}))(ProjectListPartial);

export default ProjectList;